import { Builder, DiffContent, Entity } from "../base";

class KeyValue implements Entity<KeyValue> {
  private _uuid: string;
  private _key : string;
  private _value: any;
  private _valueType: ValueType;

  constructor(json:KeyValueJSON) {
    this._uuid = json.uuid;
    this._key = json.key;
    this._value = json.value;
    this._valueType = json.valueType;
  }

  get uuid () { return this._uuid; }
  get key() { return this._key; }
  get value() { return this._value; }
  get valueType() { return this._valueType; }

  static unit = new KeyValue({uuid: "", key:"", value: "", valueType: ""});
  static identity() {
      return KeyValue.unit;
  }

  builder(): KeyValueBuilder {
    return new KeyValueBuilder(this);
  }

  toJson(): KeyValueJSON {
    return {
      uuid: this._uuid,
      key: this._key,
      value: this._value,
      valueType: this._valueType
    }
  }
}

class KeyValueBuilder implements Builder<KeyValue> {
  private _uuid: string;
  private _key : string;
  private _value: any;
  private _valueType: ValueType;
  private _diff: KeyValueDiff = {};

  constructor(keyValue?: KeyValue) {
    const kv = keyValue || KeyValue.identity()
    this._uuid = kv.uuid;
    this._key = kv.key;
    this._value = kv.value;
    this._valueType = kv.valueType;
  }

  build(): KeyValue {
    return new KeyValue({uuid: this._uuid, key: this._key, value: this._value, valueType: this._valueType});
  }

  uuid(uuid:string) {
    if (this._uuid !== uuid) {
      this._diff.uuid = uuid;
    }
    this._uuid = uuid;
    return this;
  }

  key(key:string) {
    if (this._key !== key) {
      this._diff.key = key;
    }
    this._key = key;
    return this;
  }

  value(value:any) {
    if (this._value !== value) {
      this._diff.value = stringifyValue(this._valueType, value);
    }
    this._value = value;
    return this;
  }

  valueType(valueType:ValueType) {
    if (this._valueType !== valueType) {
      this._diff.valueType = valueType;
    }
    this._valueType = valueType;
    return this;
  }


  applyDiff(diff: KeyValueDiff): Builder<KeyValue> {
    diff.uuid && this.uuid(diff.uuid);
    diff.key && this.key(diff.key);
    diff.valueType && this.valueType(diff.valueType);
    diff.value && this.value(parseValue(this._valueType, diff.value));
    return this;
  }

  applyObj(obj: KeyValue): Builder<KeyValue> {
    this.uuid(obj.uuid);
    this.key(obj.key);
    this.valueType(obj.valueType);
    this.value(obj.value);
    return this;
  }

  getDiff(): KeyValueDiff {
    return this._diff;
  }
}

function parseValue(type:ValueType, value:string) : any {
  if (type === "string") {
    return value;
  }
  if (type === "boolean") {
    return JSON.parse(value);
  }
  throw new Error("Unknown value type");
}

function stringifyValue(type:ValueType, value:any) : string {
  if (type === "string") {
    return value;
  }
  if (type === "boolean") {
    return JSON.stringify(value);
  }
  throw new Error("Unknown value type");
}

type ValueType = "" | "string" | "boolean";

interface KeyValueJSON {
  uuid: string,
  key: string,
  value: string,
  valueType: ValueType,
}

interface KeyValueDiff extends DiffContent<KeyValue> {
  key?: string,
  value?: string,
  valueType?:ValueType,
}


class Config extends KeyValue {
  static STORE = "Config"
}

export { Config, KeyValue, KeyValueBuilder, KeyValueDiff, KeyValueJSON, ValueType }